module.exports = __webpack_public_path__ + "static/media/p1s.50205b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p1s.png
// module id = 261
// module chunks = 0